// Migrated from Dayforce: UI\Framework\Scripts\Framework\Modules\FilterUtil.ts

/**
 * A simple module that allows users to add filters or categories to the array.
 * @module FilterUtil
 */
export const FilterUtil = {
    /*
     * List of widgets that have notifyBindings() which causes propChange in filterpane to fire when loading/resetting filters
     */
    listWidgets: {
        "Framework/UI/Form/MultiEntitySelector": true,
        "Framework/UI/Form/LimitedMultiEntitySelector/LimitedMultiEntitySelector":
            true,
        "Framework/UI/Form/TagPicker": true,
    },
    /*
     * Creates a json object for filter and adds it to the given array.
     * @param arrayObject The array that you want to append the filter json object to
     * @param field The field that the widget maps to
     * @param displayName The display name of the filter
     * @param editorType The input widget
     * @param type The data type that the filter group is filtering against
     * @param filterOn The property of the input widget used for filtering
     * @param operationType The operation type (optional)
     * @param additionalProps Additional properties that you want to add to this filter (optional)
     *
     * Optional Props: editorProps - Additional properties that you want to set on the input widget
     *                 editorMixin - The mixin to apply on editor
     *                 isDefault - Determines whether or not the filter should automatically be added to the filter pane on startup
     *                 compareAgainstField - Specifies that the value in this filter group is actually the value from another column/property.
     *                 showOperationType - Determines whether or not you want to show/hide the operation type entity selector
     */
    addFilter: function (
        arrayObject,
        field,
        displayName,
        editorType,
        type,
        filterOn,
        operationType?,
        additionalProps?
    ) {
        const jsonObject = {
            field: field,
            displayName: displayName,
            editorType: editorType,
            filterOn: filterOn,
            type: type,
            operationType: operationType,
        };

        // add additional props to filter
        for (const key in additionalProps) {
            if (this.listWidgets[editorType]) {
                additionalProps["editorProps"] =
                    additionalProps["editorProps"] || {}; //make sure we have editorProps before setting any property
                additionalProps["hideDeleteButton"] =
                    additionalProps["hideDeleteButton"] || false;
                additionalProps[key].notifyBindingsOnRowClickOnly = true; //prevents propChange from firing unnecessarily in filterpane
            }
            jsonObject[key] = additionalProps[key];
        }

        arrayObject.push(jsonObject);
    },
    /*
     * Creates a json object for category and adds it to the given array.
     * @param arrayObject The array that you want to append the category json object to
     * @param displayName The category display name
     * @param filters An array of filters
     */
    addCategory: (arrayObject, displayName, filters) => {
        const jsonObject = {
            displayName: displayName,
            filters: filters,
        };
        arrayObject.push(jsonObject);
    },
};
